module.exports = __webpack_public_path__ + "img/the-safety-compare.c1725ef2.png";